import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './NavUtilityCluster.module.css';

export type NavUtilityClusterProps = {
  children: ReactNode;
  /** Accessible name for the grouped controls. */
  label?: string;
  className?: string;
};

/**
 * Shared quiet shell for header utility icons (inbox, messages, …).
 * Pair with `NavIconFlyout` `triggerVariant="ghost"` and a divider before account.
 */
export function NavUtilityCluster({
  children,
  label = 'Notifications',
  className,
}: NavUtilityClusterProps) {
  return (
    <div className={cx(styles.cluster, className)} role="group" aria-label={label}>
      {children}
    </div>
  );
}

export type NavHeaderDividerProps = {
  className?: string;
};

/** Thin rule between utility cluster and account control. */
export function NavHeaderDivider({ className }: NavHeaderDividerProps) {
  return <span className={cx(styles.divider, className)} aria-hidden />;
}
